import florencia from "../../../image/pizza/florencia.webp";
import peperoni from "../../../image/pizza/peperoni.webp";
import sicilia from "../../../image/pizza/sicilia.webp";
import parma from "../../../image/pizza/parma.webp";

export const imagePizza = {
    florencia: florencia,
    peperoni: peperoni,
    sicilia: sicilia,
    parma: parma,
}